import { findClientsWithPaymentsBySellerCompanyGroupedDate } from '../../_services/client.service';

export const findSellerPaymentsGroupedDateEvent = async () => {
    let res = await findClientsWithPaymentsBySellerCompanyGroupedDate();
    if(! res.ok) throw new Error(res.error);
    return res;
}